var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTierBg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.91 1.275C142.583 0.681119 144.968 3.06558 144.374 5.73854L129.649 72.0128C129.53 72.5473 129.53 73.1013 129.649 73.6357L144.374 139.91C144.968 142.583 142.583 144.967 139.91 144.374L73.6362 129.649C73.1018 129.53 72.5478 129.53 72.0133 129.649L5.73903 144.374C3.06607 144.967 0.681607 142.583 1.27549 139.91L16.0005 73.6357C16.1192 73.1013 16.1192 72.5473 16.0005 72.0128L1.27549 5.73854C0.681607 3.06558 3.06607 0.681119 5.73903 1.275L72.0133 16C72.5478 16.1187 73.1018 16.1187 73.6362 16L139.91 1.275Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8628 42.0801L87.9133 57.8768L103.71 72.9273L87.9133 87.9777L72.8628 103.774L57.8124 87.9777L42.0156 72.9273L57.8124 57.8768L72.8628 42.0801Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8063 34.1447C73.5164 33.1673 72.1322 33.1673 71.8423 34.1447L61.4711 69.1098L46.3302 107.813C45.9515 108.781 47.0888 109.632 47.9109 108.996L72.1975 90.2049C72.5666 89.9193 73.0821 89.9193 73.4511 90.2049L97.7377 108.996C98.5598 109.632 99.6971 108.781 99.3185 107.813L84.1776 69.1098L73.8063 34.1447Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3325 78.9834L39.6256 102.475",
    stroke: "#D6D6D6",
    strokeWidth: 3.82833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierBg4);
export default __webpack_public_path__ + "static/media/tier-bg-4.f8f0954efaaeb39d920ffabad39eac13.svg";
export { ForwardRef as ReactComponent };